(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prod-installation-instructions"] && !Shopify.designMode) return;
  try {
    

    $('#generatePDF').on('click',function(){
       $("html, body").animate({
          scrollTop: $(document).height() 
        }, 3000);
          let userAgent = navigator.userAgent;
          if( userAgent.match(/chrome|chromium|crios/i) && $(window).width()<992){
        setTimeout(function(){
           var divToPrint= document.getElementById('installtion-pdf');
          var newWin=window.open('','Print-Window');
           newWin.document.open();
           newWin.document.write(`<html><body onload="window.print()">${divToPrint.innerHTML}</body></html>`);
           newWin.document.close();    
           setTimeout(function(){newWin.close();},6000);
          },4000);  
       }
          else if(userAgent.match(/safari/i) && $(window).width()<992){
            setTimeout(function(){
              var htmlElement = document.querySelector("html");
           var divToPrint= document.getElementById('installtion-pdf');
          var newWin=window;
           newWin.document.write(`<html><body onload="window.print()">${divToPrint.innerHTML}</body></html>`);
           newWin.document.close();    
           setTimeout(function(){
             newWin.document.write(htmlElement.innerHTML);
             alert("Please refresh the page");
             // newWin.close();
           },6000);
          },4000);  
          }
          else{
       setTimeout(function(){
        var markup = document.getElementsByTagName('html');
         console.log(markup);
         var mywindow = window;   
          mywindow.document.write(document.getElementById('installtion-pdf').innerHTML); 
          mywindow.print();  
         mywindow.document.close();
         location.reload(); // Use of this line?
         //  mywindow.document.documentElement.innerHTML = "";
         // mywindow.document.write(markup.innerHTML);
          },4000); 
          }
    });
        var Name = "Not known";
        if (navigator.appVersion.indexOf("Win") != -1){
           Name = "Windows OS";
        }
        else if (navigator.appVersion.indexOf("Mac") != -1){
          Name = "MacOS";
        } 
        else if (navigator.appVersion.indexOf("X11") != -1){
          Name = "UNIX OS";
         // $('.installation-topdetails').addClass("linux");
        } 
        else if (navigator.appVersion.indexOf("Linux") != -1){
          Name = "Linux OS";
           // $('.installation-topdetails').addClass("linux");
        } 
        else{
            console.log("sorry");
        }
        function fnBrowserDetect(){
                 
         let userAgent = navigator.userAgent;
         let browserName;
        var v = "Version: " + navigator.appVersion;
        console.log(navigator.appVersion);
        
    

         if( userAgent.match(/chrome|chromium|crios/i)){
           var split_val =  v.split("Chrome/");
           var split_again = split_val[1].split(".");
           if(split_again[0] < 108){
             browserName = "chrome";
             $('.installation-topdetails').addClass("linux");
           }else{
             browserName = "chrome";
           }
             
           }else if(userAgent.match(/firefox|fxios/i)){
             browserName = "firefox";
              $('.installation-section .steps-section').addClass("firefox");
           }  else if(userAgent.match(/safari/i)){
             browserName = "safari";
           }else if(userAgent.match(/opr\//i)){
             browserName = "opera";
           } else if(userAgent.match(/edg/i)){
             browserName = "edge";
           }else{
             browserName="No browser detection";
           }
         
        console.log('app details',browserName);
  }
    fnBrowserDetect();


  } catch(e) { console.error(e); }
})();
})();
